<template>
  <div>
    <div id="map" class="map"></div>
    <div ref="pointInfo">
      <v-popover trigger="manual" offset="16"
                placement="top" :open="pointInfo.open">

        <template slot="popover">
          <p class="popover-content popover-content--dark-blue"> {{ pointInfo.name }}</p>
          <p class="popover-content"> {{ pointInfo.data }} </p>
        </template>

      </v-popover>
    </div>
  </div>
</template>

<script>
  import MapControlHelper from '@/services/map/control';
  import { mapGetters, mapActions } from 'vuex';
  import MapHelper from '@/services/map';
  import { VPopover } from 'v-tooltip';
  import Overlay from 'ol/Overlay';
  import View from 'ol/View';
  import Map from 'ol/Map';

  export default {
    components: {
      VPopover,
    },
    data() {
      return {
        map: null,
        pointInfo: {
          name: null,
          data: null,
          element: null,
          open: false,
        },
      };
    },
    computed: mapGetters({
      coordinates: 'locations/coordinates',
    }),
    mounted() {
      this.getCoordinates().then(() => {
        this.createMap();
        this.addPopoverOnMap();
        this.listenEvents();
      });
    },
    methods: {
      createMap() {
        const baseMapLayer = MapHelper.createOpenStreetLayer();
        const featuresLayer = MapHelper.createVectorLayer(this.coordinates);
        const settings = MapHelper.settings();
        this.map = new Map({
          layers: [baseMapLayer, featuresLayer],
          target: 'map',
          view: new View({
            center: settings.center,
            zoom: settings.zoom,
            minZoom: settings.zoom,
            projection: settings.projection,
          }),
        });

        this.map.addControl(MapControlHelper.centerToUserLocation(this.map));
      },
      listenEvents() {
        this.map.on('pointermove', (event) => {
          this.pointInfo.open = false;

          const pixel = this.map.getEventPixel(event.originalEvent);
          this.map.getViewport().style.cursor = this.map.hasFeatureAtPixel(pixel) ? 'pointer' : '';

          this.map.forEachFeatureAtPixel(
            pixel,
            this.showPointInfo,
            { hitTolerance: MapHelper.settings.clickMargin },
          );
        });
      },
      addPopoverOnMap() {
        this.pointInfo.element = new Overlay({ element: this.$refs.pointInfo, stopEvent: false });
        this.map.addOverlay(this.pointInfo.element);
      },
      showPointInfo(feature) {
        this.pointInfo.open = false;
        const coordinates = feature.getGeometry().getCoordinates();
        this.pointInfo.element.setPosition(coordinates);
        this.pointInfo.name = feature.get('name') || this.$t('locations.not_identified');
        this.pointInfo.data = feature.get('data');
        this.pointInfo.open = true;
      },
      ...mapActions({
        getCoordinates: 'locations/getCoordinates',
      }),
    },
  };
</script>



// WEBPACK FOOTER //
// src/screens/Locations/components/Map.vue